/**
 * Classe que gerencia a funcionalidade de filtrar as permissões.
 * @author: Adalto Junior <adaltojunior@sagaranatech.com>
 * Date: 20/09/13
 * Time: 09:58
 */


Greenmile.GroupPermissions = Greenmile.GroupPermissions || {};

Greenmile.GroupPermissions.FilterPermissions = (function () {

    function FilterPermissions () {

        Monet.UI.AjaxFilter.apply(this, arguments);

        this.createBaseStructure();

        var filterUserInterfaces = (function (scope) {

            return function (userInterface) {

                var error      = null,
                    pattern    = '',
                    regex      = null,
                    wordExists = null;

                try {

                    pattern = scope.input.value;
                    regex = new RegExp(pattern, 'i');
                    wordExists = userInterface.name.match(regex);

                    if (!wordExists) {
                        userInterface = null;
                    }

                    return userInterface;

                } catch (e) {

                    error = new Monet.Exception.ReturnError(this,
                        'Error on filter permission');
                    error.console();

                }

                return userInterface;

            };


        })(this);

        var filterModule = function (module) {

            var _module = module.userInterfaces.filter(filterUserInterfaces);

            if (_module.length) {
                module.userInterfaces = _module;
            } else {
                module = null;

            }

            return module;

        };

        this.callbackForSearch = function () {

            var error        = null,
                nodes        = {},
                newNodes     = [],
                treeViewPermissions,
                valueToParse = '';

            try {

                valueToParse = JSON.stringify(Monet.Session.GroupPermission.nodes);
                nodes = JSON.parse(valueToParse);

                if (this.input.value) {
                    newNodes = nodes.filter(filterModule);
                    Monet.Session.GroupPermission.permissionIsFiltered = true;
                } else {
                    newNodes = Monet.Session.GroupPermission.nodes;
                    Monet.Session.GroupPermission.permissionIsFiltered = false;
                }

                treeViewPermissions = new Greenmile.GroupPermissions.TreeViewPermissions();
                treeViewPermissions.render(newNodes);

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    'Error on callback for search on filter permissions');
                error.console();

            }

        };


    }

    FilterPermissions.prototype = new Monet.UI.AjaxFilter();

    return FilterPermissions;

})();
